import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import IconButton from '@mui/material/IconButton'

const AscendIcon = ({ isAscend, onClick }) => (
  <IconButton
    onClick={onClick}
    sx={(theme) => ({
      display: 'flex',
      flexDirection: 'column',
      margin: '0 5px',
      position: 'relative',
      '& svg': { position: 'absolute' },
      '& svg:first-of-type': {
        color: isAscend
          ? theme.palette.tertiary.main
          : theme.palette.secondary.main,
        top: '-3px'
      },
      '& svg:last-of-type': {
        color: isAscend
          ? theme.palette.secondary.main
          : theme.palette.tertiary.main,
        top: '3px'
      }
    })}
  >
    <ArrowDropUpIcon />
    <ArrowDropDownIcon />
  </IconButton>
)

export default AscendIcon
